import request from '@/utils/request'


// 获取用户手机号码
export function selectPhone() {
  return request({
    url: 'rest/clue/common/user/selectPhone.do',
    method: 'get',
  })
}

// 修改用户手机号码
export function updatePhone(phoneNum) {
  return request({
    url: 'rest/clue/common/user/updatePhone.do',
    method: 'get',
    params: {
      phoneNum
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/layout.js